// extracted by mini-css-extract-plugin
export default {"root":"style_root__b8DNT","inputWater":"style_inputWater__YJ-Ca"};